<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import axios from "axios";
import CalendarDay from "./calendar-day";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Posts List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, CalendarDay },
  data() {
    return {
      gridData: {
        data: [],
        total: 0,
      },
      title: "Posts List",
      model: "Post",
      items: [
        {
          text: "Dashboard",
          href: "/dashboard"
        },
        {
          text: 'Posts List',
          active: true
        }
      ],
      submitted: false,
      theads: ["Calendar", "Posted By", "Details", "Action"],
      isLoadingGetList: false,
      isLoadingPost: false,
      filter: {
        paginate_count: 10,
        page: 1,
        room_id: 0,
        subject_id: 0,
        item_id: 0,
        user_id: 0
      },
      token: null,
      list_error_messages: [],
      showFilterOptions: true,
      roomList: [],
      subjectList: [],
      itemList: [],
      userList: []
    };
  },
  async mounted(){
    
    this.token = await localStorage.getItem('authToken')

    this.getList();
    this.getRoomList();
    this.getSubjectList();
    this.getItemList();
    this.getUserList()
  },
  watch: {
    'filter.page': function(){
      this.getList();
    }
  },
  methods: {
    getItemList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/item')
      .then(res => {
        this.itemList = res.data.data;

        this.itemList.unshift({
          id: 0,
          name: 'Select All Items'
        });
      })
    },
    getSubjectList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/subject')
      .then(res => {
        this.subjectList = res.data.data;

        this.subjectList.unshift({
          id: 0,
          name: 'Select All Subjects'
        });
      })
    },
    getRoomList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/room/getIndex', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.roomList = res.data.data;

        this.roomList.unshift({
          id: 0,
          name: 'Select All Rooms'
        });
      })
    },
    getUserList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/user', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.userList = res.data.data;

        this.userList.unshift({
          id: 0,
          name: 'Select All Users'
        });
      })
    },
    onDelete(data){
      Swal.fire({
        title: "Delete "+ this.model + "?",
        text: "Delete selected "+ this.model +". You can restore it later!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          axios.post(process.env.VUE_APP_API + '/post/' + data.id, {
            _method: 'DELETE'
          }, {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(res => {
            Swal.fire("Deleted!", this.model + ' has been removed', "success");
            this.getList();
          })
          .catch(err => {
            if('response' in err){
              if('data' in err.response){
                if('message' in err.response.data){
                  this.list_error_messages = err.response.data.data;
                }
              }
            }
          })
        }
      });
    },
    getList(){
      this.isLoadingGetList = true;

      let filter = 'room_id=' + this.filter.room_id + '&subject_id=' + this.filter.subject_id + '&item_id=' + this.filter.item_id + '&user_id=' + this.filter.user_id;

      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/post?page=' + this.filter.page + '&paginate_count=' + this.filter.paginate_count + '&' + filter, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.gridData = res.data.data;
        this.list_error_messages = [];
      })
      .catch(err => {
        this.err = err;
      })
      .finally(() => {
        this.isLoadingGetList = false;
      });
    },
    onClickCreate(){
      this.$router.push({ name: "Create Post" });
    },
    onEdit(post){
      this.$router.push({ name: "Edit Post", params: { id: post.id } });
    },
    renderFileIcon(attachment){
      let filetype = attachment.name;
      
      if(filetype.includes('png') || filetype.includes('jpg') || filetype.includes('jpeg') || filetype.includes('gif') || filetype.includes('svg')){
        return 'bx bxs-file-image text-primary';
      } else if(filetype.includes('pdf')){
        return 'bx bxs-file-pdf text-danger';
      } else if(filetype.includes('word') || filetype.includes('doc') || filetype.includes('docx')){
        return 'bx bxs-file-doc text-primary';
      } else if(filetype.includes('excel') || filetype.includes('xls') || filetype.includes('xlsx')){
        return 'bx bxs-file-excel text-success';
      } else if(filetype.includes('powerpoint') || filetype.includes('ppt') || filetype.includes('pptx')){
        return 'bx bxs-file text-danger';
      } else {
        return 'bx bxs-file text-dark';
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="col">
              <b-alert show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                {{ err }}
              </b-alert>
            </div>
            <div class="col-12 text-center plan-btn mb-3">
              <a
                @click="showFilterOptions = !showFilterOptions"
                class="btn btn-primary btn-sm position-relative"
              >{{ showFilterOptions ? 'Hide' : 'Show' }} Filter Options</a>
            </div>
            <div class="mt-3 mb-3 bg-light py-2 row" v-if="showFilterOptions">
              <div class="col-sm col-md-6 mb-1" v-if="$store.getters['auth/isAdmin']">
                <select
                  id="inputRoom"
                  v-model="filter.user_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="user.id" v-for="(user, index) in userList" :key="`user_${index}`">{{user.name}}</option>
                </select>
              </div>
              <div class="col-sm col-md-6 mb-1">
                <select
                  id="inputRoom"
                  v-model="filter.room_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="room.id" v-for="(room, index) in roomList" :key="`room_${index}`">{{room.name}}</option>
                </select>
              </div>
              <div class="col-sm col-md-6 mb-1">
                <select
                  id="inputSubject"
                  v-model="filter.subject_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="subject.id" v-for="(subject, index) in subjectList" :key="`subject_${index}`">{{subject.name}}</option>
                </select>
              </div>
              <div class="col-sm col-md-6 mb-1">
                <select
                  id="inputItem"
                  v-model="filter.item_id"
                  class="form-control"
                  @change="getList()">
                  <option :value="item.id" v-for="(item, index) in itemList" :key="`item_${index}`">{{item.name}}</option>
                </select>
              </div>
            </div>
            <div class="right">
              <b-button @click="onClickCreate()" variant="primary">Create New {{ this.model }}</b-button>
            </div>
            <div class="table-responsive mt-2">
              <table class="table align-middle table-nowrap table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" v-for="(thead, index) in theads" :key="`head_${index}`">{{thead}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="gridData.data.length < 1 && !isLoadingGetList">
                    <td :colspan="theads.length" class="text-center"><i>--- No data available ---</i></td>
                  </tr>
                  <tr v-for="n in 3" :key="`loading_tr_${n}`" v-if="isLoadingGetList">
                    <td class="placeholder-glow" v-for="i in theads.length" :key="`placeholder_${i}`"><span class="placeholder col-12 placeholder-lg"></span></td>
                  </tr>
                  <tr v-for="(post, index) in gridData.data" v-if="!isLoadingGetList" :key="`row_${index}`">
                    <td style="width: 150px;">
                      <CalendarDay variant="text" :datetime="post.date"></CalendarDay>
                    </td>
                    <td style="width: 400px;">
                      <h5 class="font-size-14 mb-1"><span class="text-dark">{{post.user.name}}</span></h5>
                      <p class="text-muted mb-0 small">{{post.human_created_at}}</p>
                      <span class="badge me-1 mb-1 bg-primary">{{ post.year.name }}</span>
                      <span class="badge me-1 mb-1 bg-success">{{ post.room.name }}</span>
                      <span class="badge me-1 mb-1 bg-info" v-if="post.subject">{{ post.subject.name }}</span>
                      <span class="badge me-1 mb-1 bg-dark" v-if="post.item">{{ post.item.name }}</span>
                      <span class="badge me-1 mb-1 bg-danger" v-if="post.is_announcement">ANNOUNCEMENT</span>
                    </td>
                    <td style="width: 400px;">
                      <div class="mb-2">{{ post.description.length > 50 ? post.description.substring(0, 50) + '...' : post.description }}</div>
                      <span class="text-muted small" v-if="post.attachments.length">{{ post.attachments.length }} attachment(s)</span>
                      <span class="text-muted small" v-if="!post.attachments.length">No attachment</span>
                      &nbsp; - &nbsp;
                      <span class="text-muted small" v-if="post.protected_files.length">{{ post.protected_files.length }} protected file(s)</span>
                      <span class="text-muted small" v-if="!post.protected_files.length">No protected file(s)</span>
                    </td>
                    <td>
                      <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item px-2 cursor-pointer" @click="onEdit(post)">
                          <a v-b-tooltip.hover title="Edit" class="font-size-14">
                            <i class="bx bx-edit text-primary"></i> Edit
                          </a>
                        </li>
                        <li class="list-inline-item px-2 cursor-pointer" @click="onDelete(post)">
                          <a v-b-tooltip.hover title="Delete" class="font-size-14">
                            <i class="bx bx-trash-alt text-danger"></i> Delete
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3" v-if="gridData.data.length">
              <div class="col-lg-12">
                <b-pagination
                  v-model="filter.page"
                  :total-rows="gridData.total"
                  :per-page="filter.paginate_count"
                  aria-controls="my-table"
                  align="center"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>